// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GSFI","footer":"styles_footer__37_PB","passCodeTooltip":"styles_passCodeTooltip__3xoFt"};